import React, { ReactElement, FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { ResponsiveType } from '@sport1/react-elements/core/types'
import colorPattern from '../../DesignSystem/colors'
import { mapToMatchingValue } from '../../DesignSystem/utils/mapToMatchingValue'
import { radius } from '../../DesignSystem/border/radius'
import { RadiusVariants } from '../../DesignSystem/border/radius/types'
import { DimensionProps, PositionProps } from '../../Layouts/LayoutTypes'
import { TestID } from '@/utils/PropTypesDefinitions'

export type TonalProps = DimensionProps &
    PositionProps &
    TestID & {
        backgroundColor?: string
        position?: 'relative' | 'absolute' | 'fixed'
        pointerEvents?: 'none' | 'auto' | 'box-none' | 'box-only'
        zIndex?: number
        onPress?: () => void
        opacity?: number
        borderRadius?: ResponsiveType<keyof RadiusVariants>
    }

const Tonal: FunctionComponent<TonalProps> = ({
    width = '100%',
    height = '100%',
    position = 'absolute',
    pointerEvents = 'none',
    zIndex = 2,
    onPress,
    opacity = 0.7,
    borderRadius,
    ...rest
}): ReactElement => {
    return (
        <Grid
            backgroundColor={colorPattern.onyx}
            opacity={opacity}
            width={width}
            minHeight={height}
            maxHeight={height}
            position={position}
            pointerEvents={onPress ? 'auto' : pointerEvents}
            zIndex={zIndex}
            borderRadius={mapToMatchingValue(radius, borderRadius)}
            {...rest}
        >
            {onPress && <Touchable onPress={onPress} activeOpacity={1} expand />}
        </Grid>
    )
}

export default Tonal
